export default "__VITE_ASSET__Bm9qKg6K__"